import { usePaymentThreeDomainSecure } from './usePaymentThreeDomainSecure';
import { IframeStyled } from './styled';

export type PaymentThreeDomainSecureProps = {
  title?: string;
  onSucceed?: () => void;
};

const PaymentThreeDomainSecure = ({
  title = '3D Secure payment verification',
  onSucceed,
}: PaymentThreeDomainSecureProps) => {
  const { paymentProcessingData } = usePaymentThreeDomainSecure({
    onSucceed,
  });

  if (!paymentProcessingData) return null;

  return (
    <IframeStyled height="100%" width="100%" src={paymentProcessingData.verifyUrl} title={title} />
  );
};

export default PaymentThreeDomainSecure;
